/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
	  }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
}

export type FinTokenError = "EXPIRED" | "INVALID"

export type Query = {
	/**
	 * `verifyFinToken` は Fin ログイントークン（ULID）を検証し、Intercom Identity Verification に必要な情報を返します。
	 * 認証不要のエンドポイントです（Fin.tsx から直接呼ばれます）。
	 * - トークンが有効: result に VerifyFinTokenOk を返す
	 * - 期限切れ: error: EXPIRED
	 * - 無効なトークン: error: INVALID
	 */
	verifyFinToken: VerifyFinTokenResponse
}

export type QueryVerifyFinTokenArgs = {
	param: VerifyFinTokenParam
}

export type VerifyFinTokenOk = {
	/**
	 * トークンに紐づく会社名。会社 token の場合のみ返す。
	 * LINE グループ token の場合は必ず null を返す。会社が見つからない場合も null（表示は degraded）。
	 */
	companyName: Maybe<Scalars["String"]["output"]>
	finJwt: Scalars["String"]["output"]
	intercomUserHash: Scalars["String"]["output"]
	intercomUserId: Scalars["String"]["output"]
	isFirstAccess: Scalars["Boolean"]["output"]
}

export type VerifyFinTokenParam = {
	token: Scalars["String"]["input"]
}

export type VerifyFinTokenResponse = {
	error: Maybe<FinTokenError>
	result: Maybe<VerifyFinTokenOk>
}

export type VerifyFinTokenQueryVariables = Exact<{
	param: VerifyFinTokenParam
}>

export type VerifyFinTokenQuery = {
	verifyFinToken: {
		error: FinTokenError | null
		result: {
			intercomUserId: string
			intercomUserHash: string
			isFirstAccess: boolean
			finJwt: string
			companyName: string | null
		} | null
	}
}

export const VerifyFinTokenDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "VerifyFinToken" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: { kind: "Name", value: "param" },
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: { kind: "Name", value: "VerifyFinTokenParam" },
						},
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "verifyFinToken" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "param" },
								value: {
									kind: "Variable",
									name: { kind: "Name", value: "param" },
								},
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "result" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "intercomUserId" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "intercomUserHash" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "isFirstAccess" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "finJwt" },
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "companyName" },
											},
										],
									},
								},
								{ kind: "Field", name: { kind: "Name", value: "error" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<VerifyFinTokenQuery, VerifyFinTokenQueryVariables>
